import * as i0 from '@angular/core';
import { EventEmitter, Directive, Input, Output, NgModule } from '@angular/core';
import Cleave from 'cleave.js';

/* tslint:disable */
class CleaveDirective {
    constructor(el) {
        this.el = el;
        this.creditCardTypeChanged = new EventEmitter();
        this.valueChanged = new EventEmitter();
    }
    set egovCleave(options) {
        this.options = options;
        if (this.instance)
            this.instance.destroy();
        const onCreditCardTypeChanged = (type) => {
            this.creditCardTypeChanged.emit(type);
            this.options.onCreditCardTypeChanged && this.options.onCreditCardTypeChanged();
        };
        const onValueChanged = (e) => {
            this.valueChanged.emit(e);
            this.options.onValueChanged && this.options.onValueChanged();
        };
        this.instance = new Cleave(this.el.nativeElement, { ...options, onCreditCardTypeChanged, onValueChanged });
    }
}
CleaveDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: CleaveDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
CleaveDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.1.2", type: CleaveDirective, selector: "[egovCleave]", inputs: { egovCleave: "egovCleave" }, outputs: { creditCardTypeChanged: "creditCardTypeChanged", valueChanged: "valueChanged" }, exportAs: ["cleave"], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: CleaveDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[egovCleave]',
                    exportAs: 'cleave',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { egovCleave: [{
                type: Input
            }], creditCardTypeChanged: [{
                type: Output
            }], valueChanged: [{
                type: Output
            }] } });

class CleaveModule {
}
CleaveModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: CleaveModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
CleaveModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: CleaveModule, declarations: [CleaveDirective], exports: [CleaveDirective] });
CleaveModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: CleaveModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: CleaveModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CleaveDirective],
                    exports: [CleaveDirective],
                }]
        }] });

/*
 * Public API Surface of angular-cleave
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CleaveDirective, CleaveModule };
